import { render, staticRenderFns } from "./TerminosCondiciones.vue?vue&type=template&id=1708725e&scoped=true"
import script from "./TerminosCondiciones.vue?vue&type=script&lang=js"
export * from "./TerminosCondiciones.vue?vue&type=script&lang=js"
import style0 from "./TerminosCondiciones.vue?vue&type=style&index=0&id=1708725e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1708725e",
  null
  
)

export default component.exports